
import React from 'react';
import { JobSearchResult } from '@/types/jobSearch';
import { MapPin, CalendarDays, FileText, Briefcase, Network } from 'lucide-react'; // Added Briefcase, Network

interface JobCardContentDetailsProps {
  job: JobSearchResult;
}

export const JobCardContentDetails: React.FC<JobCardContentDetailsProps> = ({ job }) => {
  const detailItems = [
    {
      icon: <MapPin className="h-3.5 w-3.5 text-muted-foreground" />,
      text: job.location || 'Location not specified',
      condition: job.location,
    },
    {
      icon: <Briefcase className="h-3.5 w-3.5 text-muted-foreground" />,
      text: job.employment_type || 'Type not specified', // Shortened for brevity
      condition: job.employment_type,
    },
    {
      icon: <CalendarDays className="h-3.5 w-3.5 text-muted-foreground" />,
      text: job.posted_date ? `Posted: ${new Date(job.posted_date).toLocaleDateString()}` : 'Post date not specified',
      condition: job.posted_date,
    },
    { // New item for Job Source
      icon: <Network className="h-3.5 w-3.5 text-muted-foreground" />, // Using Network icon for source
      text: job.source || 'Source not specified',
      condition: job.source,
    },
  ];

  return (
    <div className="space-y-2">
      {job.snippet && (
        <p className="text-muted-foreground line-clamp-3 text-xs leading-relaxed">
          <FileText className="h-3.5 w-3.5 text-muted-foreground inline-block mr-1.5 align-text-bottom" />
          {job.snippet}
        </p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 text-xs">
        {detailItems.map((item, index) =>
          item.condition ? (
            <div key={index} className="flex items-center">
              {item.icon}
              <span className="ml-1.5 text-muted-foreground">{item.text}</span>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};
